import { render } from "./UnauthenticatedLayout.vue?vue&type=template&id=084c2a8e&ts=true"
import script from "./UnauthenticatedLayout.vue?vue&type=script&lang=ts"
export * from "./UnauthenticatedLayout.vue?vue&type=script&lang=ts"

import "./UnauthenticatedLayout.vue?vue&type=style&index=0&id=084c2a8e&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__